<template>
  <RevDrawer
    :name="MODAL_NAMES.ABOUT_BATTERY"
    :title="i18n(translations.aboutBatteryHealth)"
  >
    <template #body>
      <div class="mb-24">
        <RevIllustration
          alt=""
          class="rounded-md w-full object-cover"
          :height="240"
          role="presentation"
          :src="illustration"
          :width="327"
        />
      </div>

      <h3 class="heading-2 mb-16 text-balance text-center">
        {{ i18n(translations.aboutBatteryHealth) }}
      </h3>

      <p class="mb-24">
        {{ i18n(translations.content1) }}
      </p>

      <p class="mb-24">
        {{ i18n(translations.content2) }}
      </p>

      <RevInfoBlock
        v-if="isSmartphoneCategory"
        class="mb-24"
        :icon="IconInfo"
        :title="i18n(translations.infoTitle)"
        variant="info"
      >
        <p>{{ i18n(translations.infoContent) }}</p>
        <RevLink
          target="_blank"
          to="https://help.backmarket.com/hc/ja/articles/360026656374-%E3%83%90%E3%83%83%E3%83%86%E3%83%AA%E3%83%BC%E3%81%AF%E3%81%A9%E3%81%AE%E3%81%8F%E3%82%89%E3%81%84%E6%8C%81%E3%81%A1%E3%81%BE%E3%81%99%E3%81%8B"
          >{{ i18n(translations.learnMore) }}</RevLink
        >
      </RevInfoBlock>

      <BatteryFaq :has-external-borders="false" />
    </template>
  </RevDrawer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevDrawer } from '@ds/components/Drawer'
import { RevIllustration } from '@ds/components/Illustration'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { RevLink } from '@ds/components/Link'
import { IconInfo } from '@ds/icons/IconInfo'

import BatteryFaq from '~/scopes/product/components/CustomizationFunnel/components/NewBatteryModal/components/BatteryFaq/BatteryFaq.vue'

import { MODAL_NAMES } from '../../Product-JP.constants'

import translations from './AboutBatteryModal.translations'

const { illustration, isSmartphoneCategory } = defineProps<{
  illustration: string
  isSmartphoneCategory: boolean
}>()

const i18n = useI18n()
</script>
